import { render, staticRenderFns } from "./classtype-list.vue?vue&type=template&id=766db2d3&scoped=true"
import script from "./classtype-list.vue?vue&type=script&lang=ts"
export * from "./classtype-list.vue?vue&type=script&lang=ts"
import style0 from "./classtype-list.vue?vue&type=style&index=0&id=766db2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766db2d3",
  null
  
)

export default component.exports